import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.66431 5.04208L14.1259 7.08429C14.4224 7.21804 14.4143 7.64908 14.1095 7.77361L9.53223 9.52004C9.44198 9.5627 9.36709 9.6242 9.32458 9.70625L7.29997 14.1821C7.16737 14.4796 6.73809 14.4705 6.61345 14.1642L4.86482 9.56441C4.82215 9.47371 4.76076 9.39839 4.67895 9.35553L0.217407 7.31332C-0.0791184 7.17956 -0.0710034 6.74852 0.233798 6.624L4.81103 4.87755C4.90127 4.83489 4.97617 4.7734 5.01868 4.69134L7.06034 0.217234C7.19293 -0.0802459 7.6222 -0.0712156 7.74684 0.235105L9.49548 4.83491C9.53815 4.92562 9.59954 5.00094 9.68135 5.0438L9.66431 5.04208Z"
      fill="white"
    />
  </svg>
);
export default SVGComponent;
